import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'companyNameSettingsFilterPipe'
})
export class CompanyNameSettingsFilterPipe implements PipeTransform {

  transform(value: any): any {
    let output = !_.isUndefined(value) ? value : "";
    if (output.length > 65) {
      return output.substring(0, 65) + "...";
    } else {
      return output;
    }
  }

}
